// MCP (Model Context Protocol) tools are only available in the desktop version (Tamagotchi)
// For the web version, we return an empty array
// If you need MCP support in web, consider implementing a server-side MCP proxy

export const mcp = async () => []
